/*
 * hide / show password
 */
(function () {
	document.querySelectorAll('._toggle_password').forEach(function(item) {
		item.addEventListener('click', function(event) {
			event.preventDefault();
			item.querySelectorAll('.bi').forEach(function(icon) {
				icon.classList.toggle('d-none');
			});
			item.parentElement.querySelectorAll('input').forEach(function(input) {
				if (input.type == 'password')
					input.type = 'text';
				else
					input.type = 'password';
			});
		});
	});
})();